<template>
	<div class="icon md-elevation-2" @click="$emit('change')">
		<i class="el-icon-arrow-right" :class="{ expand: open }" style="margin: auto"></i>
	</div>
</template>

<script>
export default {
	name: "button-collapse",
	props: ["open", "change"]
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/collapse-button";
</style>
